import Vue from "vue";

import {PersonnelService} from "@/common/api.service";
import {FETCH_PERSONNEL_COUNTRY_LIST,} from "./actions";
import {FETCH_PERSONNEL_COUNTRY_LIST_END,} from "./mutations";

import {SET_TOASTER_MESSAGE} from "../this_app/mutations";

const getDefaultState = () => {
    return {
        job: {},
        personnelCountryList: [],
        fatalFetchError: {
            state: false,
            value: "",
        },
    }
};

const state = getDefaultState();

const getters = {
    personnelCountryList(state) {
        return state.personnelCountryList;
    },

    getPersonnelCountryNameById: (state) => (personnelCountryId) => {
        const country = state.personnelCountryList.find(personnelCountry => personnelCountry.personnelCountryId == personnelCountryId);
        if (country) {
            return country.name;
        }
    },
};

const actions = {
    [FETCH_PERSONNEL_COUNTRY_LIST]({commit}) {
        return PersonnelService.getPersonnelCountries()
            .then(({data}) => {
                commit(FETCH_PERSONNEL_COUNTRY_LIST_END, data);
            })
            .catch(error => {
                Vue.rollbar.error(error);
                commit(SET_TOASTER_MESSAGE, {state: true, value: 'Failed to fetch countries'});
            });
    },
};

/* eslint no-param-reassign: ["error", { "props": false }] */
const mutations = {
    [FETCH_PERSONNEL_COUNTRY_LIST_END](state, data) {
        state.personnelCountryList = data;
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
